import UnavailableProductRefillCard from '@/components/products/refill/UnavailableProductRefillCard';
import { IssueStatuses } from '@/hooks/escript/types';
import type { ProductMatchIssuesProps } from './types';
import { isMatch } from './utils';

export function ProductMatchIssues({ issues }: ProductMatchIssuesProps) {
  return (
    <>
      {issues.map((pip, index) => {
        if (!pip.issue || !isMatch(pip.product)) {
          return null;
        }

        const productMatch = pip.product;
        return (
          <UnavailableProductRefillCard
            key={productMatch.name + productMatch.token + index}
            product={{
              id: 0,
              name: productMatch.name,
              price: 0,
              is_out_of_stock: productMatch.productIssueStatus === IssueStatuses.OUT_OF_STOCK,
              is_generative_scripting: false,
              reasoning_toggle: true,
              token: productMatch.token,
              brand: null,
            }}
            issue={pip.issue}
            handleCheckProductStatus={null}
          />
        );
      })}
    </>
  );
}
